import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Offer } from '../models/offer';
import { environment } from '../../environments/environment';
import { FilterOffer } from '../models/filters/filter-offer';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OfferService {

  constructor(private http: HttpClient) { }

  private apiUrl = `${environment.apiUrl}`;
  private url: string = this.apiUrl + 'api/offers'; 

  findAllPageableOffer(filterOffer: FilterOffer, page: number, pageSize: number): Observable<any> {
    return this.http.post<any[]>(`${this.url}/page/${page}/${pageSize}`, filterOffer);
  }

  findOfferById(id: number): Observable<Offer> {
    return this.http.get<Offer>(`${this.url}/${id}`);
  }

  createOffer(offer: Offer): Observable<Offer>{
    return this.http.post<Offer>(this.url, offer);
  }

  updateOffer(offer: Offer): Observable<Offer>{
    return this.http.put<Offer>(`${this.url}/${offer.id}`, offer);
  }

  recalculateOffer(offer: Offer): Observable<Offer>{
    return this.http.put<Offer>(`${this.url}/recalculation/${offer.id}`, offer);
  }

  getSignatures(offer: Offer): Observable<Offer>{
    return this.http.put<Offer>(`${this.url}/getSignatures/${offer.id}`, offer);
  }

  sendSignatures(offer: Offer): Observable<Offer>{
    return this.http.put<Offer>(`${this.url}/sendSignatures/${offer.id}`, offer);
  }
  
  sendOperate(offer: Offer): Observable<Offer>{
    return this.http.put<Offer>(`${this.url}/sendOperate/${offer.id}`, offer);
  }
  
  deleteOffer(offerId: number): Observable<number>{
    return this.http.delete<number>(`${this.url}/deleteOffer/${offerId}`).pipe(
      map(() => offerId)
    );
  }


  formulaEvaluator(id: number): Observable<any> {
    return this.http.get<any[]>(`${this.url}/formulaEvaluator/${id}`);
  }
}
